/* eslint-disable import/no-unresolved */
import { memo, useEffect } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import ProposalOtp from "src/components/ReviewDetails/ProposalOtp";
import { EInsurerType } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import { setReviewDetails } from "src/redux/Thunk";
import store from "src/redux/store";
import { getReviewDetails } from "src/services/LeadInfo";
import CustomLoader from "src/shared/CustomLoader";
import Header from "src/shared/Header";
import { useDispatch } from "react-redux";
import { MasterAction } from "src/redux/Actions/Masters";
import { SET_MEF_JOURNEY_SCHEMA } from "src/redux/Types/Masters";
import { getMefJourneySchema } from "src/services/Master";

function ReviewLeadDetails() {
  const params = useParams();
  const dispatch = useDispatch();

  const { isFetching: isReviewDetailsLoading, isError: isReviewDetailsError } = useQuery(
    ["getReviewDetails", params?.leadId],
    () => getReviewDetails(params?.leadId || ""),
    {
      refetchOnWindowFocus: false,
      retry: false,
      onSuccess: (response) => {
        store.dispatch(setReviewDetails(response.data, params?.leadId || ""));
      }
    }
  );

  const {
    isFetching: isMefSchemaLoading,
    isError: isMefSchemaError,
    refetch: refetchMefSchema
  } = useQuery(
    ["getMefJourneySchema", params?.leadId],
    () => {
      const leadData = store.getState().common.leadDetails;
      return getMefJourneySchema(leadData?.productId, leadData?.partnerId, leadData?.loanCategory);
    },
    {
      enabled: false,
      retry: false,
      onSuccess: (response) => {
        dispatch(MasterAction(SET_MEF_JOURNEY_SCHEMA, response));
      }
    }
  );

  useEffect(() => {
    if (!isReviewDetailsLoading && !isReviewDetailsError) {
      refetchMefSchema();
    }
  }, [isReviewDetailsLoading, isReviewDetailsError, refetchMefSchema]);

  if (isReviewDetailsLoading || isMefSchemaLoading) {
    return <CustomLoader />;
  }

  if (isReviewDetailsError || isMefSchemaError) {
    return (
      <div className="flex flex-col items-center mt-20 text-2xl font-bold text-hotShot">
        No Data Found
      </div>
    );
  }
  return (
    <>
      <Header isEnable />
      <div className="bg-whiteSmoke py-8 mx-auto">
        <ProposalOtp insurerType={EInsurerType.ALL} />
      </div>
    </>
  );
}

export default memo(ReviewLeadDetails);
